// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./complot.jpg')
const allTwoEs = require('./creativity1.png')
const allTwoCa = require('./creativity1.png')
const allFourEs = require('./creativity1.png')
const allFourCa = require('./creativity1.png')
const catalogTwoEs = require('./creativity1.png')
const catalogTwoCa = require('./creativity1.png')
const catalogFourEs = require('./creativity1.png')
const catalogFourCa = require('./creativity1.png')

const model = creativityMediaModel({ catalogID: 'beer', allTwoEs, allTwoCa, allFourEs, allFourCa, catalogTwoEs, catalogTwoCa, catalogFourEs, catalogFourCa })

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) => model[params.catalogID][params.numberOfColumns][params.language]
}
